import { render, staticRenderFns } from "./SoundDopplerViz.vue?vue&type=template&id=45572361&scoped=true"
import script from "./SoundDopplerViz.vue?vue&type=script&lang=js"
export * from "./SoundDopplerViz.vue?vue&type=script&lang=js"
import style0 from "./SoundDopplerViz.vue?vue&type=style&index=0&id=45572361&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45572361",
  null
  
)

export default component.exports